import { EMPTY_LIST } from '../../../constants/common'
import { FILTER_NAME_SUB_MENU } from '../../../constants/filter'
import { EXCLUDE_FILTERS } from '../../Filter'

import { ENTITY_TAB_FLATS_SCALAR_SCOPE_FILTER_KEYS } from './EntityTabFlats.constants'

export function getEntityTabFlatsExcludeFilters(scopeFilterKey) {
  return [
    ...EXCLUDE_FILTERS,
    ...(scopeFilterKey ? [scopeFilterKey] : EMPTY_LIST),
    FILTER_NAME_SUB_MENU,
  ]
}

export function getEntityTabFlatsScopeFilter({ scopeFilterKey, scopeId }) {
  return {
    [scopeFilterKey]: ENTITY_TAB_FLATS_SCALAR_SCOPE_FILTER_KEYS.includes(
      scopeFilterKey
    )
      ? scopeId
      : [scopeId],
  }
}
